var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInfoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.9 22.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #136bae;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.9,11.4c0,6.3-5.1,11.4-11.4,11.4S0,17.8,0,11.4C0,5.1,5.1,0,11.4,0s0,0,0,0C17.8,0,22.9,5.1,22.9,11.4ZM11.7,3.8c-2.2,0-4.3,1-5.4,2.9-.2.2-.1.6.1.8l1.6,1.2c.2.2.6.1.8-.1.8-1,1.4-1.6,2.6-1.6s2.1.6,2.1,1.5-.6,1-1.5,1.6c-1.1.6-2.5,1.4-2.5,3.3v.2c0,.3.2.6.6.6h2.6c.3,0,.6-.2.6-.6h0c0-1.4,3.8-1.4,3.8-5,0-2.7-2.8-4.7-5.4-4.7ZM11.4,15.2c-1.2,0-2.1.9-2.1,2.1,0,1.2.9,2.1,2.1,2.1,1.2,0,2.1-.9,2.1-2.1,0,0,0,0,0,0,0-1.2-1-2.1-2.1-2.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfoBlue);
export default __webpack_public_path__ + "static/media/icon_info_blue.254a5ce720e1225b32879c7393d6c973.svg";
export { ForwardRef as ReactComponent };